import {
  IAdjustment2SearchParam,
  IDeltaGammaTableReport,
} from "../../../Interfaces/deltaHedgeAdjustment";
import { getDeltaGammaTable } from "../../../Requests/deltaHedgeAdjustment";
import { CommonTableUI } from "../../TableTemplate/common";
import TableTemplate from "../../TableTemplate/tableTemplate";

interface IProps {
  searchParams: IAdjustment2SearchParam;
}

const DeltaGammaTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IAdjustment2SearchParam, IDeltaGammaTableReport>
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          setSortingType={setSortingType}
          sortingType={sortingType}
          tableBoxClassName="max-h-[400px] !w-full overflow-x-auto"
        />
      )}
      tableWrapperClassname="!w-full"
      getDataTable={getDeltaGammaTable}
      searchParameters={searchParams}
      withSort
      refreshTableTime={5000}
    />
  );
};

export default DeltaGammaTable;
